// Bootstrap JS.
// Comment out the library you are not using.
// -----------------------------------------------------------------------------
export { default as Alert } from 'bootstrap/js/dist/alert';
//export { default as Button } from 'bootstrap/js/dist/button';
//export { default as Carousel } from 'bootstrap/js/dist/carousel';
export { default as Collapse } from 'bootstrap/js/dist/collapse';
export { default as Dropdown } from 'bootstrap/js/dist/dropdown';
//export { default as Offcanvas } from 'bootstrap/js/dist/offcanvas';
//export { default as Modal } from 'bootstrap/js/dist/modal';
//export { default as Popover }  from 'bootstrap/js/dist/popover';
//export { default as ScrollSpy } from 'bootstrap/js/dist/scrollspy';
//export { default as Tab } from 'bootstrap/js/dist/tab';
//export { default as Toast } from 'bootstrap/js/dist/toast';
//export { default as Tooltip } from 'bootstrap/js/dist/tooltip';
